import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSolletWallet(),
      getMathWallet(),
    ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button">
          <img src="/icons/close.svg" alt="" onClick={toggleMenu} />
        </div>
        <ul>
          <li>
            <img className="mobile-nav-logo" src="/img/logo.png" alt="" />
          </li>
          <li>
            <div className="social-icons">
              <a href="https://twitter.com/DoodleMBS">
                <img className="nav-social" src="/icons/twitter.svg" alt="" />
              </a>
              <a href="https://discord.com/invite/QeT9F7Xc7j">
                <img
                  className="nav-social discord"
                  src="/icons/discord.svg"
                  alt=""
                />
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <img className="nav-logo" src="/img/doodled-monkey-logo.png" alt="" />
          <div className="social-icons hide-800">
            <a href="https://twitter.com/DoodleMBS">
              <img className="nav-social" src="/icons/twitter.svg" alt="" />
            </a>
            <a href="https://discord.com/invite/QeT9F7Xc7j">
              <img
                className="nav-social discord"
                src="/icons/discord.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </nav>
      <div className="content-wrapper">
        <img src="/img/doodled-monkey-explain.png" className="ape-img" alt="" />

        <header className="card" id="link1">
          <div style={{ padding: "0 24px 0 24px 0" }}>
            {/* <h3 className="text-secondary-color">Welcome To</h3> */}
            <img className="dooodled-smb-gif" src = "/img/doodled-smb-profile.gif" alt="" />
          </div>
          <div>
            <ThemeProvider theme={theme}>
              <ConnectionProvider endpoint={endpoint}>
                <WalletProvider wallets={wallets} autoConnect>
                  <WalletDialogProvider>
                    <Minter
                      candyMachineId={candyMachineId}
                      connection={connection}
                      startDate={startDateSeed}
                      txTimeout={txTimeout}
                      rpcHost={rpcHost}
                    />
                  </WalletDialogProvider>
                </WalletProvider>
              </ConnectionProvider>
            </ThemeProvider>
          </div>
        </header>
        <div id="link2" className="container">
          <h2 className="prize text-secondary-color">
            {" "}
            ROADMAP 
            <p>
              <li>Launch project for Doodled SMB, initiate mint</li>
              <li>Form community</li>
              <li>Launch DAO for Doodled SMB holders of Solana blockchain</li>
              <li>Each Doodled SMB holder will get the same looking Doodled SMBs on their ETH wallet</li>
              <li>Launch Doodled characters using solanaMBS traits on ETH, get interactions on ETH ecosystem</li>
              <li>Initiate mint for Doodled characters using solana MBS traits</li>
              <li>Open DAO for ETH version holders</li>
              <li>Airdrop takes place</li>
              <li>Engage with both ecosystems and invest in ETH, SOL, nfts and create a DAO that can cat like a fund</li>
              <li>inverstment returns to holders</li>
              <li>TBA</li>            
            </p>
          </h2>
          <br />
          {/* <ul>
              <li>
                <h3 className="text-secondary-color">Winner #1: 35%</h3>
              </li>
              <li>
                <h3 className="text-secondary-color">Winner #2: 25%</h3>
              </li>
              <li>
                <h3 className="text-secondary-color">Winner #1: 10%</h3>
              </li>
              <li>
                <h3 className="text-secondary-color">Winner #4-10: 1%</h3>
              </li>
              <li>
                <h3 className="text-secondary-color">OG NFT Holders: 20%</h3>
              </li>
            </ul> */}
          <div id="link4" className="container faq">
            <h1 style={{ padding: "0 0 24px 0" }}>FAQ</h1>
            <div>
              <h2>Are you affiliated with SMB or Doodles?</h2>
              <p>
              <li>We're not affiliated but we are inspired by them</li>
              <li>We are a mixed derivative project of two iconic NFTs from Ethereum and Solana blockchain willing to harmonize the users</li>              
              </p>

              <hr />
            </div>

            <div>
              <h2>Mint price?</h2>
              <p>
              <li>Mint price will be 0.1 SOL</li>
              <li>Which is calculation from Doodles mint prcie(Oct 17, 0.123ETH)</li>
              <li>SMB 5000 supply  = 70 USD</li>
              <li>Doodles 10000 supply = halving would result in 220 USD</li>
              <li>Medium = 145 USD</li>
              <li>Mint price = 145 * 10% = 0.1 SOL</li>
              </p>

              <hr />
            </div>

            <div>
              <h2>Mint Supply?</h2>
              <p>
                <li>2500 Doodled MBS(on SOL)-2500 will be airdropped to holders on ETH</li>
                <li>2500 SolanaMBS doodled(on ETH)-2500 will be airdropped to holders on SOLANA</li>
              </p>
              <hr />
            </div>
            <div>
              <h2>Airdrop?</h2>
              <p>
                <li>People who minted for Doodled MBS will get SolanaMBS doodled version on ETH</li>
              </p>
              <hr />
            </div>
            <div>
              <h2>How to mint?</h2>
              <p>
                <li>Mint will take place on our website using Solana Wallet</li>
                <li>Phantom wallet is our best recommendation</li>
              </p>
              <hr />
            </div>
            <div>
              <h2>When mint?</h2>
              <p>
                <li>22th Feb 16:00 UTC</li>
                <li>Check timer</li>
              </p>
              <hr />
            </div>
            <div>
              <h2>Secondary sale royalties?</h2>
              <p>
                <li>5%</li>
              </p>
              <hr />
            </div>
            <div>
              <h2>secondary market?</h2>
              <p>
                <li>MagicEden and others</li>
              </p>
              <hr />
            </div>               
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
